import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { isArray, isNullOrUndefined, isObject } from 'util';

import { RegionsResponseModel } from '../../models/regions-response.model';
import { GroupsResponseModel } from '../../models/groups/groups-response.model';

// TODO add unit tests, but how :)?

@Injectable()
export class WebserviceErrorInterceptor implements HttpInterceptor {
	private _observedRoutes: Array<string> = ['/regions', '/groups', '/termins'];

	public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req)
			.switchMap(res => {

				if (res instanceof HttpResponse && res.status === 200 && this._observedRoutes.find(route => !isNullOrUndefined(res.url.match(route)))) {
					const body = (res.body as (RegionsResponseModel | GroupsResponseModel));

					if (isObject(body) && isArray(body.hints) && body.hints.length > 0) {
						let status: number;

						switch (true) {
							case body.hints.indexOf('internal error - invalid response') !== -1:
								status = 500;
								break;

							case isArray(body.data) && body.data.length > 0:
								status = 200;
								break;

							default:
								status = 400;
								break;
						}

						return Observable.of(new HttpResponse({
							body: body.hints.join('<br />'),
							status
						}));
					}

					if (isObject(res.body.data) && isArray(res.body.data.data) && res.body.data.data.length === 0) {
						return Observable.of(res.clone({status: 204}));
					}
				}

				return Observable.of(res);
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/services/webservice/webservice-error.interceptor.ts